import useEvaluationsProjectEducatorQuery from '../evaluations-project-educator/useQuery';
import useEvaluationsProjectPartnerQuery from '../evaluations-project-partner/useQuery';
import useEvaluationsEventEducatorQuery from '../evaluations-event-educator/useQuery';
import useEvaluationsEventPartnerQuery from '../evaluations-event-partner/useQuery';
import { PayloadStates } from '@lore/utils';

export default function useQuery(props) {
  const evaluationsProjectEducator = useEvaluationsProjectEducatorQuery(props);
  const evaluationsProjectPartner = useEvaluationsProjectPartnerQuery(props);
  const evaluationsEventEducator = useEvaluationsEventEducatorQuery(props);
  const evaluationsEventPartner = useEvaluationsEventPartnerQuery(props);

  if (
    evaluationsProjectEducator.state !== PayloadStates.RESOLVED ||
    evaluationsProjectPartner.state !== PayloadStates.RESOLVED ||
    evaluationsEventEducator.state !== PayloadStates.RESOLVED ||
    evaluationsEventPartner.state !== PayloadStates.RESOLVED
  ) {
    return {
      state: PayloadStates.FETCHING,
      data: [],
      meta: undefined
    };
  }

  return {
    state: PayloadStates.RESOLVED,
    data: [].concat(
      evaluationsProjectEducator.data,
      evaluationsProjectPartner.data,
      evaluationsEventEducator.data,
      evaluationsEventPartner.data
    ),
    meta: {
      totalCount: (
        (evaluationsProjectEducator.meta?.totalCount || 0) +
        (evaluationsProjectPartner.meta?.totalCount || 0) +
        (evaluationsEventEducator.meta?.totalCount || 0) +
        (evaluationsEventPartner.meta?.totalCount || 0)
      )
    }
  };
}
